import type { MutationTree } from 'vuex'
import sumBy from 'lodash/sumBy'
import type { ApplicationState } from './types'
import {
  GET_APPLICATION,
  GET_LIST_APPLICATIONS,
  SET_CURRENT_PAGE,
  SET_SELECTED_ROWS,
  GET_APPLICATION_LOGS_IN_WEEK,
  SELECTED_APPLICATION_IDS,
} from './types'

export const mutations: MutationTree<ApplicationState> = {
  [GET_LIST_APPLICATIONS](state: ApplicationState, applications: ApplicationModel[]) {
    state.applications = applications
  },
  [GET_APPLICATION](state: ApplicationState, application: ApplicationModel) {
    state.application = application
  },
  [SET_CURRENT_PAGE](state: ApplicationState, numPage: number) {
    state.currentPage = numPage
  },
  [SET_SELECTED_ROWS](state: ApplicationState, rows: number) {
    state.selectedRows = rows
  },
  [GET_APPLICATION_LOGS_IN_WEEK](
    state: ApplicationState,
    resp: {
      totalLogs: number
      logsInWeek: { date: string; errorLogs: number; successLogs: number }[]
    },
  ) {
    state.logsInWeek = resp.logsInWeek
    state.totalLogsInWeek = resp.totalLogs
    state.errorLogsInWeek = sumBy(resp.logsInWeek, (obj) => obj.errorLogs)
    state.successLogsInWeek = sumBy(resp.logsInWeek, (obj) => obj.successLogs)
  },
  [SELECTED_APPLICATION_IDS](state: ApplicationState, selected: string[]) {
    state.selectedApplicationIds = selected
  },
}
